/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Destination site/channel for a MercadoLibre real-estate publication.
 */
export enum MeliPublicationTarget {
    MELI = 'meli',
    MELI_POI = 'meli_poi',
}
